import { render, staticRenderFns } from "./orgcompany.vue?vue&type=template&id=5f4b54c7&"
import script from "./orgcompany.vue?vue&type=script&lang=js&"
export * from "./orgcompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports